'use strict';

exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/getDisplayName.js
// module id = 890
// module chunks = 0